import _ from "lodash"

export type TPrimitiveId = string|number
export type TSelect<ID extends TPrimitiveId> = {
    id:ID
    text:string
}
export type TSelectRow<ID extends TPrimitiveId> = ID|TSelect<ID>

export default class Select {
    static isSelect<ID extends TPrimitiveId>(val:TSelectRow<ID>) : val is TSelect<ID> {
        const type = typeof(val)
        return type!="number" && type!="string"
    }
    static eq<ID extends TPrimitiveId>(left:TSelectRow<ID>, right:TSelectRow<ID>) {
        if (this.isSelect(left) && this.isSelect(right)) return left.id==right.id
        else return left==right
    }
    static id<ID extends TPrimitiveId>(value:TSelectRow<ID>){
        return this.isSelect(value) ? value.id : value
    }
    static text<ID extends TPrimitiveId>(value:TSelectRow<ID>){
        return this.isSelect(value) ? value.text : value.toString()
    }
    static option<ID extends TPrimitiveId, OPTION extends TSelectRow<ID>>(options:OPTION[], value:ID) : OPTION {
        return _.find(options, o => this.eq(this.id(o), value)) as OPTION
    }
    static indexOf<ID extends TPrimitiveId>(options:TSelectRow<ID>[], value:ID) {
        return _.findIndex(options, o => this.eq(this.id(o), value))
    }
}
